import { render, staticRenderFns } from "./years-months-section.vue?vue&type=template&id=c79afc54"
import script from "./years-months-section.vue?vue&type=script&lang=js"
export * from "./years-months-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports